import React from 'react';
import Box from "../components/ui-kit/box";

const NotFound = () => {
  return (
    <div className="blog-page">
      <div className="container">
        <Box className="blog">
          <h1>404 - Resource Not Found</h1>
          <p style={{ color: 'white' }}>Sorry, the page you are looking for does not exist.</p>
        </Box>
      </div>
    </div>
  );
};

export default NotFound;
